import { instance } from '../utils/axios';
import { useNavigate } from 'react-router-dom'
import { logoutRoute } from '../utils/API_Routes';
import { useDispatch } from 'react-redux';
import { setAuth } from '../features/auth/authSlice';
import { removeUser } from '../features/user/userSlice';
import { resetChatState } from '../features/chat/chatSlice';

const useLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const logout = async () => {
        dispatch(setAuth({}))
        try {
            await instance.post(logoutRoute, {}, {
                withCredentials: true
            })
            dispatch(removeUser())
            dispatch(resetChatState());
            navigate('/login')
        } catch (error) {
            console.log(error);
        }
    }
    return logout;
}

export default useLogout